import React from 'react';
import styled from 'styled-components';

const IframeWrapperDIV = styled.div`
  position: relative;
  margin: var(--spacing--M) 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const IframeWrapper = props => {
  let aspectRatio = '56.25%';
  if (props.width && props.height) {
    aspectRatio = `${props.height / props.width * 100}%`;
  }
  return (
    <IframeWrapperDIV style={{ paddingTop: aspectRatio }}>
      <iframe {...props} title={props.title || 'Embedded Video'} />
    </IframeWrapperDIV>
  )
};

export default IframeWrapper;